import { useFormikContext, Field } from "formik";
import React from "react";
import ErrorMessage from "../components/ErrorMessage"
function ValueCare() {

 
  const { errors, touched } = useFormikContext();
  const [showResults, setShowResults] = React.useState(false)
  const onClick = () => setShowResults(true)
  const hideResult = () => setShowResults(false)
   return (
    <div>
      <h1>About you</h1>
        <ErrorMessage errors={errors} touched={touched}/>
      <fieldset>
        <legend>Is the total value of your savings over £23,250? </legend>
        <p class="hint-text">This includes all your bank accounts and say any other savings and investments such as ISA's, Premium Bonds, shares and Post Office savings, but not the value of your property.</p>
        <div>
          <div className="form__radio form__control">
            <Field type="radio" name="valueover" value="1" id="valueover_yes" onClick={hideResult}/>
            <label htmlFor="valueover_yes" ><span>Yes</span></label>
          </div>
          <div className="form__radio form__control">
            <Field type="radio" name="valueover" value="0" id="valueover_no" onClick={onClick} />
            <label htmlFor="valueover_no"><span>No</span></label>
          </div>
          { showResults &&
          
          <div id="reveal-propertyq" class="radio__reveal">
  <div class="form-group form__control">
    <h3 class="heading3">Do you own or part-own the property you live in? </h3>
    <p class="hint-text">The value of your home will only be taken into account if you are moving into long-term residential care.</p>

    <div className="form__radio form__control"> 
      <Field type="radio" name="ownproperty" value="1" id="ownproperty_yes"/>
      <label htmlFor="ownproperty_yes"><span>Yes</span></label>
    </div>

    <div className="form__radio form__control">
      <Field type="radio" name="ownproperty" value="0" id="ownproperty_no"/>
      <label htmlFor="ownproperty_no"><span>No</span></label>
    </div>
  </div>
  <div>
    <h3 class="heading3">Do you own or part-own another property which has a value over £23,250?</h3>  
    <div className="form__radio form__control">
      <Field type="radio" name="ownpropertyoutsideuk" value="1" id="ownpropertyoutsideuk_yes"/>
      <label htmlFor="ownpropertyoutsideuk_yes"><span>Yes</span></label>
    </div>
    <div className="form__radio form__control"> 
      <Field type="radio" name="ownpropertyoutsideuk" value="0" id="ownpropertyoutsideuk_no"/>
      <label htmlFor="ownpropertyoutsideuk_no"><span>No</span></label>
    </div> 
  </div>
</div>
}
        </div>
      </fieldset>
      <fieldset>
        <legend>What type of care do you need?</legend>
        <div className="form__radio form__control">
          <Field type="radio" name="typeofcare" value="0" id="typeofcare_home"/>
          <label htmlFor="typeofcare_home"><span>Care at home</span></label>
        </div>
        <div className="form__radio form__control">
          <Field type="radio" name="typeofcare" value="1" id="typeofcare_residential"/>
          <label htmlFor="typeofcare_residential"><span>Residential</span></label>
        </div>
        <div className="form__radio form__control">
          <Field type="radio" name="typeofcare" value="2" id="typeofcare_shortstayrespite"/>
          <label htmlFor="typeofcare_shortstayrespite"><span>Short stay</span></label>
        </div>
      </fieldset>
    </div> 
  );
}
export default ValueCare;